"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Info(_ref) {
  var className = _ref.className,
      fill = _ref.fill;

  return _react2.default.createElement(
    "svg",
    { focusable: "false", "aria-hidden": true, className: "icon-svg-info " + className, preserveAspectRatio: "xMinYMin meet", viewBox: "0 0 16 16" },
    _react2.default.createElement("path", { fill: fill, className: "path1", d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM7 3.75c0-0.413 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.337 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5zM10 13h-4v-1h1v-4h-1v-1h3v5h1v1z" })
  );
}

Info.propTypes = {
  className: _react.PropTypes.string,
  fill: _react.PropTypes.string
};

exports.default = Info;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Info/Info.js
// module id = 200
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14